import { IonImg } from '@ionic/react';
import NoAccessImage from '../../assets/adminOnly.png';
import { useUserHasRole } from '../../hooks/useUserHasRole';
export const AdminOnly: React.FC<{
	children: JSX.Element;
}> = ({ children }) => {
	const admin = useUserHasRole('admin');
	return (
		<>
			{!admin ? (
				<div className="pageContainer">
					<IonImg src={NoAccessImage}></IonImg>
					<div>You need to be an admin to view this page.</div>
				</div>
			) : (
				<>{children}</>
			)}
		</>
	);
};
